<template>
  <v-container class="py-6" fluid>
    <v-row no-gutters>
      <v-col cols="12" class="text-left">
        <h1 class="text-h4 font-weight-bold mb-1 primary--text">{{ title }}</h1>
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>